module.exports = __webpack_public_path__ + "static/media/carouselOne.e3e1a2bd.png";